import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const MyOrder = lazy(() => import("@/pages/MyOrder/MyOrder"));

const SalesOrder = lazy(() => import("@/pages/SalesOrder/SalesOrder"));
const PrimarySalesOrder = lazy(() => import("@/pages/SalesOrder/PrimarySalesOrder/PrimarySalesOrder"));

const SecondarySales = lazy(() => import("@/pages/SalesOrder/SecondarySalesOrder/SecondarySales"));
const SecondarySalesOrder = lazy(() => import("@/pages/SalesOrder/SecondarySalesOrder/SecondarySalesOrder"));
const ViewOrderItems = lazy(() => import("@/pages/SalesOrder/SecondarySalesOrder/ViewOrderItems"));

const SalesInvoice = lazy(() => import("@/pages/SalesInvoice/SalesInvoice"));
const PrimarySalesInvoice = lazy(() => import("@/pages/SalesInvoice/PrimarySalesInvoice/PrimarySalesInvoice"));

const DistributorInventory = lazy(() => import("@/pages/DistributorInventory/DistributorInventory"));

const OrderManagementRoute: RouteConfig = {
    path: "",
    pageName: "Order Management",
    sidebar: {
        show: true,
        icon: "/assets/media/orderLogo.svg",
    },
    children: {
        MY_ORDER: {
            path: "myorder",
            element: <MyOrder />,
            pageName: "My Order",
            sidebar: { show: true },
            permission: ["OrdersView"],
        },
        SALES_ORDER: {
            path: "sales-order",
            element: <SalesOrder />,
            pageName: "Sales Order",
            sidebar: { show: true },
            permission: ["SalesOrderView"],
            children: {
                PRIMARY_SALES_ORDER: {
                    path: "primary",
                    element: <PrimarySalesOrder />,
                    pageName: "Primary Sales Order",
                    sidebar: { show: true },
                },
                SECONDARY_SALES_ORDER: {
                    path: "secondary",
                    element: <SecondarySales />,
                    pageName: "Secondary Sales Order",
                    sidebar: { show: true },
                    children: {
                        LIST: {
                            path: "",
                            element: <SecondarySalesOrder />,
                            pageName: "Secondary Sales Order",
                            sidebar: { show: false },
                        },
                        VIEW_ORDER_ITEMS: {
                            path: "view/:orderId",
                            element: <ViewOrderItems />,
                            pageName: "Secondary Sales Order",
                            sidebar: { show: false },
                        },
                    },
                },
            },
        },
        SALES_INVOICE: {
            path: "sales-invoice",
            element: <SalesInvoice />,
            pageName: "Sales Invoice",
            sidebar: { show: true },
            permission: ["SalesInvoiceView"],
            children: {
                PRIMARY_SALES_INVOICE: {
                    path: "primary",
                    element: <PrimarySalesInvoice />,
                    pageName: "Primary Sales Invoice",
                    sidebar: { show: true },
                },
            }
        },
        DISTRIBUTOR_INVENTORY: {
            path: "distributor-inventory",
            element: <DistributorInventory />,
            pageName: "Distributor Inventory",
            sidebar: { show: true },
            permission: ["DistributorInventoryView"],
        }
    }
};

export default OrderManagementRoute;